import { type TagText } from 'types/wellbeing';

export const TAG_DIRECTION = {
  HORIZONTAL: 'horizontal',
  VERTICAL: 'vertical',
} as const;

export interface TagListProps {
  tagsText?: TagText[];
  direction?: (typeof TAG_DIRECTION)[keyof typeof TAG_DIRECTION];
}
